import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {Link} from 'react-router-dom';
import defaultAvatar from '../../resources/img/user-icon-big.png';
import FaCog from 'react-icons/lib/fa/cog';
import FaSignOut  from 'react-icons/lib/fa/sign-out';
import LastComments from "../lastcomments/lastcomments.component";
import CinemapAccordionItem from '../../../SHARED/components/accordionitem/accordionitem.component';
import SavedItem from '../../../SHARED/components/saveditem/saveditem.component';
import CarouselTickets from "../../../SHARED/components/carouseltickets/carouseltickets.component";
import CarouselRatings from "../../../SHARED/components/carouselratings/carouselratings.component";
import FavCinemas from "../../../SHARED/components/favcinemas/favcinemas.component";
import SavedNews from "../../../SHARED/components/savednews/savednews.component";
import {getYourRatings, getNotificationList, getUserDetails} from '../../../SHARED/actions/profile.actions';
import { getOrdersList } from "../../../SHARED/actions/payment.actions"
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import Moment from "react-moment";
import 'moment/locale/ro';
import moment from "moment";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import {LOGIN_ROUTE} from "../../../SHARED/config/routes";
import Parser from 'html-react-parser';
import {requestLoginGuest} from '../../../SHARED/actions/user.actions';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';

class Profile extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
        if(window.localStorage.getItem('login_type') !== 'authenticated') {
            this.props.history.push(LOGIN_ROUTE);
        }

        // this.props.getUserDetails();
        this.props.getYourRatings();
        this.props.getNotificationList();
        this.props.getOrdersList();
    }

    componentDidMount() {
        pageViewEvent('Profil - Cinemap', window.location.href);
    }

    getNotificationList = () => {
        if(this.props.notifications.rows){
            return this.props.notifications.rows.map((notification, i) => {
                return (
                    <CinemapAccordionItem key = {i}
                        id={notification.notif_id}
                        type={notification.notif_type}
                        uuid = {notification.notif_uuid}
                        title={notification.notif_title}
                        preview={notification.notif_message.slice(0, 150) + '...'}
                        body={notification.notif_message}
                        articleId={notification.notif_reference_details}
                        seen={notification.notif_seen !== "0" ? true : false}
                    />
                )
            })
        }
    }

    getTickets = () => {
        if (this.props.tickets.rows) {
            let tickets = [];
            this.props.tickets.rows.map((ticket, i) => {
                tickets.push({
                    imgSrc: ticket.film.film_poster,
                    title: ticket.film.film_title,
                    subtitle: ticket.film.film_translated_title,
                    year: ticket.film.film_release_year,
                    status: ticket.order_status,
                    date: ticket.schedule_date,
                    hour: ticket.schedule_broadcast_hour,
                    cinema: ticket.cinema.cinema_name,
                });
            })
            return tickets;
        }
    };

    getRatings = () => {
        return this.props.yourRetings.rows
    };

    getSearches = () => {
        return [
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                imdb_note: '8.7'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                imdb_note: '8.7'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                imdb_note: '8.7'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                imdb_note: '8.7'
            },
            {
                imgSrc: 'https://i.imgur.com/KDlgGUQ.jpg',
                title: 'Ant-Man and the Wasp',
                year: '2018',
                imdb_note: '8.7'
            },
        ];
    };

    logout = () => {
        window.localStorage.clear();
        this.props.requestLoginGuest();
        this.props.history.push("/autentificare");
    }

    getRatingsCount = () => {
        if ( this.props.yourRetings.pager) {
            return this.props.yourRetings.pager.total_items
        }
        else {
            return 0;
        }
    }

    getTotalTickets = () => {
        if (this.props.tickets.pager) {
            return this.props.tickets.pager.total_items
        }
        else {
            return 0;
        }
    }

    getAges = () => {
        if (this.props.userDetails.date_of_birth){
            let date = moment(this.props.userDetails.date_of_birth).format("YYYY-MM-DD");
            return <p>{moment().diff(date, 'years', false)} ani</p>;
        }    
    }

    render() {
        const yourRetingsCount = this.props.yourRetings.pager ? this.props.yourRetings.pager.total_items : 0;
        //const date_of_birth = !this.props.userDetails.date_of_birth ? moment.unix(this.props.userDetails.date_of_birth).format("YYYY-MM-DD") : "";
        return !this.props.userDetails ? null :
            (<div className="profile-page">
                {this.props.loading !== 0 ? <Spinner/> : ''}
                <Helmet>
                    <title>Profil - Cinemap</title>
                    <meta name="description" content="Pagina de profil a contului tău."/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-lg-12">
                                    {
                                        <div className="first-section clearfix">
                                            <div className="avatar float-left">
                                                <img
                                                    src={this.props.userDetails.picture ? API_URL + Parser(this.props.userDetails.picture) : defaultAvatar}
                                                    alt="Avatar" className="img-circle w-100"/>
                                            </div>
                                            <div className="right-details">
                                                <span
                                                    className="profile-name">{this.props.userDetails.first_name + ' ' + this.props.userDetails.last_name}</span>
                                                <span className="profile-email">{this.props.userDetails.email}</span>
                                                <span className="profile-years">
                                                {this.getAges()}
                                            </span>
                                                <span className="profile-joined">
                                            Membru din {' '}
                                                    <Moment format="MMMM YYYY" locale="ro" unix>
                                                        {this.props.userDetails.account_created}
                                                    </Moment>
                                            </span>
                                                {/* <p className="profile-add-description">Adauga o descriere</p> */}
                                                <Link to="profil/editare"><FaCog className="profile-settings-icon"/></Link>
                                                <FaSignOut className="profile-logout-icon" onClick={this.logout}/>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12 profile-item">
                                    <div className="profile-item-header">
                                        <span className="envelope-icon">
                                            <span className="notif-icon icon-email float-left"/>
                                        </span>
                                        <span
                                            className="profile-notif-summary">Notificări ({this.props.notificationCount.notif_count} nevizualizate)</span>
                                    </div>

                                    <div className="accordion">
                                        {this.getNotificationList()}
                                    </div>
                                </div>

                                <div className="col-lg-12 profile-item">
                                    <div className="saved-by-you">
                                        <SavedItem/>
                                    </div>
                                </div>

                                <div className="col-lg-12 profile-item">
                                    <div className="my-tickets">
                                        <div className="profile-item-header ">
                                            <span className="icon-tickets float-left"/>
                                            <span className="profile-notif-summary">Biletele tale ({this.getTotalTickets()})</span>
                                        </div>
                                        <CarouselTickets cards={this.getTickets()} defaultSlidesToShow={4}/>
                                    </div>
                                </div>

                                <div className="col-lg-12 profile-item">
                                    <div className="my-ratings">
                                        <div className="profile-item-header ">
                                            <span className="icon-rating float-left"/>
                                            <span
                                                className="profile-notif-summary">Ratingurile tale ({this.getRatingsCount()})</span>
                                        </div>
                                        <CarouselRatings cards={this.getRatings()} defaultSlidesToShow={4}/>
                                    </div>
                                </div>

                                <div className="col-lg-12 profile-item">
                                    <div className="my-cinemas">
                                        <FavCinemas/>
                                    </div>
                                </div>

                                <div className="col-lg-12 profile-item">
                                    <div className="my-news">
                                        <SavedNews/>
                                    </div>
                                </div>

                                {/* <div className="col-lg-12 profile-item">
                                    <div className="my-searches">
                                        <div className="profile-item-header ">
                                            <span className="icon-searches float-left"/>
                                            <span className="profile-notif-summary">Ultimele tale cautari</span>
                                            <span className="notif-delete float-right"/>
                                            <span className="delete-history">Sterge istoric</span>
                                        </div>
                                        <CarouselSearches cards={this.getSearches()} defaultSlidesToShow={4}/>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <LastComments/>
                        </div>
                    </div>
                </div>
                
            </div>);
    }
}

const mapStateToProps = state => ({
    yourRetings: state.profile.yourRetings,
    notificationCount: state.profile.notificationCount,
    userDetails: state.profile.userDetails,
    notifications: state.profile.notifications,
    loading: state.loading.pendingRequests,
    tickets: state.payment.ordersList
});
export default withRouter(connect(mapStateToProps, {getYourRatings, getNotificationList, getUserDetails, getOrdersList, requestLoginGuest})(Profile));


// WEBPACK FOOTER //
// ./src/FO/components/profile/profile.component.js